import { render } from "./BnTable.vue?vue&type=template&id=c18fb980"
import script from "./BnTable.vue?vue&type=script&lang=js"
export * from "./BnTable.vue?vue&type=script&lang=js"

import "./BnTable.vue?vue&type=style&index=0&id=c18fb980&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__